import React from 'react';
import images from '../../assets';
import './ServiceCard.scss';

function ServiceCard({ item }) {
    return (
        <div
            className="service-item"
            style={{
                background: `url(${images[item?.img]})`,
                backgroundSize: 'cover',
            }}
        >
            <div className="service-overlay" />
            <span className="service-name">{item?.name}</span>
            <p className="service-desc">{item?.desc}</p>
        </div>
    );
}

export default ServiceCard;
